import { useEffect } from "react";
import type { ComponentProps } from "react";
import { getComponentName } from "@aviv-unified-frontend/internal";
import type { CreateApplicationOutput } from "@aviv-unified-frontend/runtime/lifecycle";

import type { Id } from "./types";
import { useRuntimeApplication } from "./useRuntimeApplication";

export const createRuntimeWrapper = (
  id: Id,
  Component: CreateApplicationOutput["Component"],
) => {
  const WrappedComponent = (props: ComponentProps<typeof Component>) => {
    const { setId } = useRuntimeApplication();

    useEffect(() => {
      setId(id);
    }, [setId]);

    return <Component {...props} />;
  };

  WrappedComponent.displayName = `createRuntimeWrapper(${getComponentName(
    Component,
  )})`;

  return WrappedComponent;
};
